/* ============================================================
   EmptyPocketsDesigns theme
   Small, dependency-free behaviors. Everything degrades:
   without JS the forms still post and the pages still read.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var money = function (cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  /* ---------- mobile nav ---------- */
  var navBtn = $('[data-nav-toggle]');
  if (navBtn) {
    navBtn.addEventListener('click', function () {
      var nav = $('#MainNav');
      var open = nav.classList.toggle('is-open');
      navBtn.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- accordions (product FAQ, contact FAQ) ---------- */
  $$('[data-accordion]').forEach(function (acc) {
    acc.addEventListener('click', function (e) {
      var btn = e.target.closest('.acc__btn');
      if (!btn || !acc.contains(btn)) return;

      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      // Only one panel open at a time, matching the mockup.
      $$('.acc__btn', acc).forEach(function (other) {
        other.setAttribute('aria-expanded', 'false');
        var sign = $('.acc__sign', other);
        if (sign) sign.textContent = '+';
        var p = document.getElementById(other.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      });

      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        var sign = $('.acc__sign', btn);
        if (sign) sign.textContent = '−';
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
      }
    });
  });

  /* ---------- quantity steppers (product page) ---------- */
  $$('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = $('[data-qty-input]', btn.closest('.qty').parentNode) || $('[data-qty-input]');
      if (!input) return;
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- variant picker ---------- */
  (function initVariants() {
    var root = $('[data-product-root]');
    var json = $('[data-variant-json]');
    if (!root || !json) return;

    var data;
    try { data = JSON.parse(json.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var currency = data.currency;

    var idInput   = $('[data-variant-id]', root);
    var priceEl   = $('[data-price]', root);
    var addBtn    = $('[data-add-btn]', root);
    var addLabel  = $('[data-add-label]', root);
    var qtyInput  = $('[data-qty-input]', root);
    var mainImage = $('#PdpMainImage', root);

    function selectedOptions() {
      var picked = [];
      $$('input[type="radio"][data-option-index]', root).forEach(function (input) {
        if (input.checked) picked[parseInt(input.dataset.optionIndex, 10)] = input.value;
      });
      return picked;
    }

    function matchVariant(picked) {
      return variants.find(function (v) {
        return picked.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }

    function paintChecked() {
      $$('input[type="radio"][data-option-index]', root).forEach(function (input) {
        var label = input.closest('label');
        if (label) label.setAttribute('aria-checked', String(input.checked));
      });
    }

    function render() {
      var picked = selectedOptions();
      var variant = matchVariant(picked);
      paintChecked();

      // The "Color: Shop green" line above each option row.
      picked.forEach(function (val, i) {
        var lbl = $('[data-option-label="' + i + '"]', root);
        if (lbl && val) lbl.textContent = val;
      });

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        priceEl.innerHTML = variant.price_formatted +
          (variant.compare_at_price > variant.price ? '<s>' + variant.compare_formatted + '</s>' : '');
      }

      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image;
        mainImage.srcset = '';
      }

      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) {
        addLabel.textContent = variant.available
          ? 'Add to cart · ' + money(variant.price * qty, currency)
          : 'Sold out';
      }

      // Keep the URL shareable and back-button friendly.
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* older browsers: skip */ }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"][data-option-index]') || e.target.matches('[data-qty-input]')) render();
    });

    // Swatch/pill labels are focusable; make space/enter select them.
    root.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Enter') return;
      var label = e.target.closest('.swatch, .opt-btn');
      if (!label) return;
      e.preventDefault();
      var input = $('input', label);
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });

    render();
  })();

  /* ---------- product gallery thumbs ---------- */
  $$('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = $('#PdpMainImage');
      if (!main) return;
      main.src = thumb.dataset.full;
      main.srcset = '';
      $$('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- quick add from a card ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();

    var btn = $('button', form);
    var original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding'; btn.disabled = true; }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number($('[name="id"]', form).value), quantity: 1 }]
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refreshCartCount(); })
      .then(function () { if (btn) btn.textContent = 'Added'; })
      .catch(function () {
        // Anything unexpected: fall back to a normal form post so the
        // customer still ends up with the item in their cart.
        form.removeAttribute('data-quick-add');
        form.submit();
      })
      .finally(function () {
        setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1400);
      });
  });

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      });
  }

  /* ---------- cart line quantities ---------- */
  (function initCart() {
    var form = $('[data-cart-form]');
    if (!form) return;

    function changeLine(index, quantity) {
      form.style.opacity = '.55';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: index, quantity: quantity, sections: 'main-cart' })
      })
        .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
        .then(function (state) {
          // Section Rendering API gives back fresh HTML for just the cart.
          var html = state.sections && state.sections['main-cart'];
          if (!html) { window.location.reload(); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#shopify-section-main-cart') || doc.body;
          var current = document.querySelector('#shopify-section-main-cart');
          if (current) { current.innerHTML = fresh.innerHTML; } else { window.location.reload(); return; }
          refreshCartCount();
          initCart();
        })
        .catch(function () { window.location.reload(); })
        .finally(function () { form.style.opacity = ''; });
    }

    $$('[data-line-qty]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.dataset.index, 10);
        var input = form.querySelector('[data-line-input][data-index="' + index + '"]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.lineQty, 10));
        changeLine(index, next);
      });
    });

    $$('[data-line-input]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        changeLine(parseInt(input.dataset.index, 10), Math.max(0, parseInt(input.value, 10) || 0));
      });
    });

    $$('[data-remove]', form).forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        changeLine(parseInt(link.dataset.remove, 10), 0);
      });
    });
  })();

  /* ---------- collection sort ---------- */
  var sortForm = $('[data-sort-form]');
  if (sortForm) {
    var select = $('select[name="sort_by"]', sortForm);
    if (select) select.addEventListener('change', function () { sortForm.submit(); });
  }

  /* ---------- chip labels double as radios in the wizard ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.chip input[type="radio"]')) return;
    var name = e.target.name;
    $$('input[type="radio"][name="' + CSS.escape(name) + '"]').forEach(function (input) {
      input.closest('.chip').classList.toggle('is-active', input.checked);
    });
  });

  /* ---------- custom-fit wizard ---------- */
  (function initWizard() {
    var wiz = $('[data-wizard]');
    if (!wiz) return;
    var form = $('form', wiz);
    if (!form) return;

    var steps = $$('[data-wiz-step]', wiz);
    if (!steps.length) return;              // success state: nothing to drive
    var back = $('[data-wiz-back]', wiz);
    var next = $('[data-wiz-next]', wiz);
    var submit = $('[data-wiz-submit]', wiz);
    var label = $('[data-wiz-label]', wiz);
    var current = 1;
    var last = steps.length;

    function stepValid(n) {
      var step = steps[n - 1];
      var ok = true;
      // Radio groups
      $$('[data-wiz-required]', step).forEach(function (group) {
        if (!$('input:checked', group)) ok = false;
      });
      // Text inputs
      $$('input[required], textarea[required]', step).forEach(function (input) {
        if (!input.checkValidity()) ok = false;
      });
      return ok;
    }

    function fillReview() {
      $$('[data-wiz-review]', wiz).forEach(function (el) {
        var name = el.dataset.wizReview;
        var field = form.querySelector('[name="' + CSS.escape(name) + '"]:checked') ||
                    form.querySelector('[name="' + CSS.escape(name) + '"]');
        var val = field ? String(field.value).trim() : '';
        if (val) {
          el.textContent = val;
        } else {
          el.textContent = name === 'contact[Notes]' ? 'No notes added' : 'Not provided';
        }
      });

      // Compose the message body Shopify actually emails.
      var body = $('[data-wiz-body]', wiz);
      if (body) {
        var get = function (name) {
          var f = form.querySelector('[name="' + CSS.escape(name) + '"]:checked') ||
                  form.querySelector('[name="' + CSS.escape(name) + '"]');
          return f ? String(f.value).trim() : '';
        };
        body.value =
          'Custom fit request\n' +
          'Tool brand: ' + (get('contact[Tool brand]') || 'Not provided') + '\n' +
          'What needs a home: ' + (get('contact[What needs a home]') || 'Not provided') + '\n' +
          'Notes: ' + (get('contact[Notes]') || 'None') + '\n\n' +
          'Photo to follow by email reply.';
      }
    }

    function show(n) {
      current = n;
      steps.forEach(function (s, i) { s.hidden = (i + 1) !== n; });
      $$('[data-wiz-bar]', wiz).forEach(function (bar) {
        bar.classList.toggle('is-on', parseInt(bar.dataset.wizBar, 10) <= n);
      });
      if (label) label.textContent = 'Step ' + n + ' of ' + last;
      if (back) back.hidden = n === 1;
      if (next) next.hidden = n === last;
      if (submit) submit.hidden = n !== last;
      if (n === last) fillReview();
      wiz.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    if (next) next.addEventListener('click', function () {
      if (!stepValid(current)) {
        // Let the browser point at the first thing that is missing.
        var step = steps[current - 1];
        var firstInvalid = $$('input, textarea', step).find(function (i) { return !i.checkValidity(); });
        if (firstInvalid) { firstInvalid.reportValidity(); }
        else { alert('Pick one from each row to continue.'); }
        return;
      }
      show(Math.min(last, current + 1));
    });

    if (back) back.addEventListener('click', function () { show(Math.max(1, current - 1)); });

    show(1);
  })();

  /* ---------- address delete confirmation ---------- */
  $$('[data-address-delete]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (!window.confirm(link.dataset.confirmMessage || 'Delete this address?')) { e.preventDefault(); return; }
      e.preventDefault();
      var form = document.createElement('form');
      form.method = 'post';
      form.action = link.getAttribute('href');
      form.innerHTML = '<input type="hidden" name="_method" value="delete">';
      document.body.appendChild(form);
      form.submit();
    });
  });

  /* ---------- related products ---------- */
  (function initRelated() {
    var holder = $('[data-related]');
    if (!holder) return;
    var url = holder.dataset.related;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section');
        if (section && section.innerHTML.trim()) holder.innerHTML = section.innerHTML;
      })
      .catch(function () { /* recommendations are a nicety; stay quiet */ });
  })();

  /* ============================================================
     7.1 Extension builder: one row per part type in one color,
     any quantity; ADD ALL posts every non-zero row to /cart/add.js
     in a single call, one line item per row (duplicates merged).
     ============================================================ */
  (function initBuilder() {
    var root = $('[data-builder]');
    if (!root) return;
    var jsonEl = $('[data-builder-json]', root);
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var ci = parseInt(root.dataset.colorIndex, 10);
    var pi = parseInt(root.dataset.partIndex, 10);
    var threshold = parseInt(root.dataset.threshold, 10) || 0;
    var currency = data.currency;
    var colors = data.colors || {};
    var rowsEl = $('[data-builder-rows]', root);
    var tpl = $('template[data-builder-row]', root);
    var addBtn = $('[data-builder-add]', root);
    var submit = $('[data-builder-submit]', root);
    var status = $('[data-builder-status]', root);
    var cartTotal = 0;

    // key "Color||Part" -> variant
    var map = {};
    (data.variants || []).forEach(function (v) { map[v.options[ci] + '||' + v.options[pi]] = v; });

    function key(row) {
      return $('[data-brow-color]', row).value + '||' + $('[data-brow-part]', row).value;
    }
    function qtyOf(row) {
      var n = parseInt($('[data-brow-input]', row).value, 10);
      return isNaN(n) || n < 0 ? 0 : Math.min(n, 999);
    }
    function paintRow(row) {
      var v = map[key(row)];
      var qty = qtyOf(row);
      $('[data-brow-input]', row).value = qty;
      var ok = !!(v && v.available);
      row.classList.toggle('is-unavailable', !ok);
      $('[data-brow-error]', row).hidden = ok;
      $('[data-brow-total]', row).textContent = money(ok ? v.price * qty : 0, currency);
      var dot = $('[data-brow-dot]', row);
      if (dot) dot.style.background = colors[$('[data-brow-color]', row).value] || '#3a4044';
      return ok;
    }
    function recalc() {
      var rows = $$('[data-brow]', rowsEl);
      var parts = 0, total = 0, blocked = false;
      rows.forEach(function (row) {
        var ok = paintRow(row);
        var qty = qtyOf(row);
        if (qty === 0) return;
        if (!ok) { blocked = true; return; }
        parts += qty;
        total += map[key(row)].price * qty;
      });
      $('[data-builder-count]', root).textContent = parts + (parts === 1 ? ' part' : ' parts');
      $('[data-builder-total]', root).textContent = money(total, currency);
      var ship = $('[data-builder-ship]', root);
      if (ship && threshold > 0) {
        var sub = total + cartTotal;   // cart subtotal after this build lands
        ship.textContent = sub >= threshold ? 'Free shipping unlocked' : money(threshold - sub, currency) + ' to free shipping';
      }
      submit.disabled = parts === 0 || blocked;
    }
    function addRow(part, color, qty) {
      var frag = tpl.content.cloneNode(true);
      var row = $('[data-brow]', frag);
      if (part) $('[data-brow-part]', row).value = part;
      if (color) $('[data-brow-color]', row).value = color;
      $('[data-brow-input]', row).value = qty || 0;
      rowsEl.appendChild(frag);
      recalc();
    }

    // Opening state: one row per part type, quantity 0, default color.
    var partOpts = $$('option', $('[data-brow-part]', tpl.content)).map(function (o) { return o.value; });
    var colorOpts = $$('option', $('[data-brow-color]', tpl.content)).map(function (o) { return o.value; });
    var defColor = colorOpts.indexOf(root.dataset.defaultColor) >= 0 ? root.dataset.defaultColor : colorOpts[0];
    partOpts.forEach(function (part) { addRow(part, defColor, 0); });

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-brow]')) recalc();
    });
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-brow-input]')) recalc();
    });
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-brow-qty]');
      if (step) {
        var row = step.closest('[data-brow]');
        var input = $('[data-brow-input]', row);
        input.value = Math.max(0, qtyOf(row) + parseInt(step.dataset.browQty, 10));
        recalc();
        return;
      }
      var rm = e.target.closest('[data-brow-remove]');
      if (rm) {
        rm.closest('[data-brow]').remove();
        if (!$('[data-brow]', rowsEl)) addRow(partOpts[0], defColor, 0);
        recalc();
      }
    });
    addBtn.addEventListener('click', function () {
      addRow(partOpts[0], defColor, 0);
      var last = $$('[data-brow]', rowsEl).pop();
      var sel = last && $('[data-brow-part]', last);
      if (sel) sel.focus();
    });

    submit.addEventListener('click', function () {
      // Merge rows that resolve to the same variant.
      var merged = {};
      $$('[data-brow]', rowsEl).forEach(function (row) {
        var qty = qtyOf(row);
        var v = map[key(row)];
        if (!qty || !v || !v.available) return;
        merged[v.id] = (merged[v.id] || 0) + qty;
      });
      var items = Object.keys(merged).map(function (id) { return { id: Number(id), quantity: merged[id] }; });
      if (!items.length) return;

      var label = submit.textContent;
      submit.disabled = true; submit.textContent = 'Adding';
      status.textContent = '';

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'add failed'); return j; }); })
        .then(function () { return refreshCartCount(); })
        .then(function (cart) {
          if (cart) cartTotal = cart.total_price;
          var n = items.reduce(function (s, i) { return s + i.quantity; }, 0);
          status.innerHTML = n + (n === 1 ? ' part' : ' parts') + ' added as ' + items.length + (items.length === 1 ? ' line' : ' lines') +
            '. <a href="' + root.dataset.cartUrl + '">View cart</a> or keep building.';
          $$('[data-brow-input]', rowsEl).forEach(function (i) { i.value = 0; });
          recalc();
        })
        .catch(function (err) {
          status.textContent = 'Could not add that build: ' + err.message + '. Nothing was charged; try again.';
          submit.disabled = false;
        })
        .finally(function () { submit.textContent = label; });
    });

    // Existing cart subtotal makes the free-shipping line honest.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartTotal = cart.total_price || 0; recalc(); })
      .catch(function () { /* keep the build-only figure */ });
  })();

  /* ============================================================
     7.2 Badge personalizer: text + colors are line item properties;
     a third color switches the variant to "3 Colors".
     ============================================================ */
  (function initPersonalizer() {
    var form = $('[data-personalizer]');
    if (!form) return;
    var data = {};
    try { data = JSON.parse($('[data-badge-json]', form).textContent); } catch (e) { /* preview colors are cosmetic */ }
    var colors = data.colors || {};
    var currency = data.currency;

    var idInput = $('[data-variant-id]', form);
    var text = $('[data-badge-text]', form);
    var border = $('[data-badge-color="border"]', form);
    var secondary = $('[data-badge-color="secondary"]', form);
    var third = $('[data-badge-color="third"]', form);
    var qty = $('[data-qty-input]', form);
    var priceEl = $('[data-price]');
    var addTotal = $('[data-add-total]', form);
    var errEl = $('[data-badge-error]', form);
    var preview = $('[data-badge-preview]', form);
    var previewText = $('[data-badge-preview-text]', form);
    var stripe = $('[data-badge-preview-stripe]', form);

    var two = { id: form.dataset.twoId, price: parseInt(form.dataset.twoPrice, 10) || 0 };
    var three = { id: form.dataset.threeId, price: parseInt(form.dataset.threePrice, 10) || two.price };

    function render() {
      var usesThird = third && third.value && third.value !== 'None';
      var v = usesThird ? three : two;
      if (idInput) idInput.value = v.id;
      var n = Math.max(1, parseInt(qty && qty.value, 10) || 1);
      if (priceEl) priceEl.textContent = money(v.price, currency);
      if (addTotal) addTotal.textContent = money(v.price * n, currency);

      if (preview) {
        var b = colors[border.value] || '#3adb63';
        var s = colors[secondary.value] || '#191c1e';
        preview.style.borderColor = b;
        preview.style.background = s;
        preview.style.color = b;
        previewText.textContent = (text.value || 'YOUR TEXT').toUpperCase();
        if (stripe) {
          stripe.hidden = !usesThird;
          if (usesThird) stripe.style.background = colors[third.value] || '#f26722';
        }
      }
    }

    form.addEventListener('input', render);
    form.addEventListener('change', render);
    form.addEventListener('submit', function (e) {
      if (text.value.trim()) { errEl.hidden = true; return; }
      e.preventDefault();
      errEl.hidden = false;
      text.focus();
    });
    render();
  })();

})();
